import React from 'react';
import { PawPrint } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-brand-brown-light/30 py-10 mt-10" data-id="element-47">
      <div className="max-w-4xl mx-auto px-6 flex flex-col items-center justify-center text-center gap-4" data-id="element-48">
        <Logo size={56} data-id="element-49" />
        <div className="flex gap-3 text-brand-brown" data-id="element-50">
          <PawPrint className="w-5 h-5" data-id="element-51" />
          <PawPrint className="w-5 h-5 opacity-70" data-id="element-52" />
          <PawPrint className="w-5 h-5 opacity-40" data-id="element-53" />
        </div>
        <div data-id="element-54">
          <p className="font-bold text-brand-text" data-id="element-55">Sestri za tačke © 2026</p>
          <p className="text-sm text-brand-text/70 mt-1" data-id="element-56">
            📍 Krško in okolica · 🐾 Z ljubeznijo narejeno
          </p>
        </div>
      </div>
    </footer>;
}